import { render, staticRenderFns } from "./ContentsTitle.vue?vue&type=template&id=6e474186&"
import script from "./ContentsTitle.vue?vue&type=script&lang=js&"
export * from "./ContentsTitle.vue?vue&type=script&lang=js&"
import style0 from "./ContentsTitle.vue?vue&type=style&index=0&id=6e474186&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports